

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const UsersPage = () => {
//   const [users, setUsers] = useState([]);
//   const [editUser, setEditUser] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1); // For pagination
//   const usersPerPage = 10; // Number of users per page
//   const navigate = useNavigate();

//   const fetchUsers = () => {
//     axios.get('/api/v1/admin/users', { withCredentials: true })
//       .then(res => setUsers(res.data))
//       .catch(err => console.error(err));
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleDelete = async (userId) => {
//     if (!window.confirm('Are you sure you want to delete this user?')) return;

//     try {
//       await axios.delete(`/api/v1/admin/users/${userId}`, {
//         withCredentials: true
//       });
//       fetchUsers();
//     } catch (err) {
//       console.error('Delete error:', err);
//       alert('Failed to delete user');
//     }
//   };

//   const handleEdit = (user) => {
//     setEditUser(user);
//     setModalOpen(true);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       await axios.put(`http://localhost:8080/api/v1/admin/users/${editUser._id}`, editUser, {
//         withCredentials: true
//       });

//       fetchUsers();
//       setModalOpen(false);
//     } catch (err) {
//       console.error('Edit error:', err);
//       alert('Failed to update user');
//     }
//   };

//   // Pagination calculations
//   const indexOfLastUser = currentPage * usersPerPage;
//   const indexOfFirstUser = indexOfLastUser - usersPerPage;
//   const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);
//   const totalPages = Math.ceil(users.length / usersPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   return (
//     <div className="flex-1 p-8 ">
//       <h2 className="text-2xl font-semibold mb-4">Users</h2>
//       <div className="bg-white p-6 rounded-xl shadow overflow-x-auto">
//         <table className="w-full text-left border-collapse">
//           <thead>
//             <tr className="text-gray-700 border-b">
//               <th className="py-2 px-4">UserId</th>
//               <th className="py-2 px-4">Name</th>
//               <th className="py-2 px-4">Mobile</th>
//               {/* <th className="py-2 px-4">Gender</th> */}
//               <th className="py-2 px-4">Role</th>
//               <th className="py-2 px-4">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentUsers.map(user => (
//               <tr key={user._id} className="border-b hover:bg-gray-50">
//                 <td className="py-2 px-4">{user._id}</td>
//                 <td className="py-2 px-4">{user.username}</td>
//                 <td className="py-2 px-4">{user.mobileNumber}</td>
//                 {/* <td className="py-2 px-4">{user.gender}</td> */}
//                 <td className="py-2 px-4">
//                   {user.isRole === 1 ? 1 : 2}
//                 </td>
//                 <td className="py-2 px-4 space-x-2">
//                   <button onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} className="text-blue-600 hover:text-blue-800">👁 View</button>
//                   <button onClick={() => handleEdit(user)} className="text-yellow-600 hover:text-yellow-800">✏ Edit</button>
//                   {user.isRole === 1 ? (
//                     <button className="text-gray-400 cursor-not-allowed" disabled title="Admin user cannot be deleted"> 🗑 Delete</button>
//                   ) : (
//                     <button onClick={() => handleDelete(user._id)} className="text-red-600 hover:text-red-800">🗑 Delete </button>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Pagination Buttons */}
//         <div className="flex justify-center mt-4 space-x-2">
//           {Array.from({ length: totalPages }, (_, index) => (
//             <button
//               key={index + 1}
//               onClick={() => paginate(index + 1)}
//               className={`px-3 py-1 rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
//             >
//               {index + 1}
//             </button>
//           ))}
//         </div>

//       </div>

//       {/* Edit User Modal */}
//       {modalOpen && (
//         <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
//           <div className="bg-white p-6 rounded-xl shadow-lg w-96">
//             <h3 className="text-xl font-semibold mb-4">Edit User</h3>
//             <input
//               type="text"
//               value={editUser.username}
//               onChange={(e) => setEditUser({ ...editUser, username: e.target.value })}
//               placeholder="Name"
//               className="mb-4 p-2 border border-gray-300 rounded w-full"
//             />
//             <input
//               type="text"
//               value={editUser.mobileNumber}
//               onChange={(e) => setEditUser({ ...editUser, mobileNumber: e.target.value })}
//               placeholder="Mobile"
//               className="mb-4 p-2 border border-gray-300 rounded w-full"
//             />
//             {/* <input
//               type="text"
//               value={editUser.gender}
//               onChange={(e) => setEditUser({ ...editUser, gender: e.target.value })}
//               placeholder="Gender"
//               className="mb-4 p-2 border border-gray-300 rounded w-full"
//             />
//             <input
//               type="text"
//               value={editUser.status}
//               onChange={(e) => setEditUser({ ...editUser, status: e.target.value })}
//               placeholder="Status"
//               className="mb-4 p-2 border border-gray-300 rounded w-full"
//             />
//             <input
//               type="number"
//               value={editUser.isRole}
//               onChange={(e) => setEditUser({ ...editUser, isRole: parseInt(e.target.value) })}
//               placeholder="Role (1 for Admin, 2 for User)"
//               className="mb-4 p-2 border border-gray-300 rounded w-full"
//             /> */}

//             <div className="flex justify-between">
//               <button onClick={() => setModalOpen(false)} className="text-gray-600 hover:text-gray-800">Cancel</button>
//               <button onClick={handleSaveEdit} className="bg-blue-600 text-white px-4 py-2 rounded">Save</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UsersPage;



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const navigate = useNavigate();

  const fetchUsers = () => {
    axios.get('/api/v1/admin/users', { withCredentials: true })
      .then(res => setUsers(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleDelete = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;

    try {
      await axios.delete(`/api/v1/admin/users/${userId}`, {
        withCredentials: true
      });
      fetchUsers();
    } catch (err) {
      console.error('Delete error:', err);
      alert('Failed to delete user');
    }
  };

  const handleEdit = (user) => {
    setEditUser(user);
    setModalOpen(true);
  };

  const handleSaveEdit = async () => {
    try {
      await axios.put(`http://localhost:8080/api/v1/admin/users/${editUser._id}`, editUser, {
        withCredentials: true
      });

      fetchUsers();
      setModalOpen(false);
    } catch (err) {
      console.error('Edit error:', err);
      alert('Failed to update user');
    }
  };

  // Pagination calculations
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(users.length / usersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="flex-1 p-4 md:p-8">
      <h2 className="text-xl md:text-2xl font-semibold mb-4">Users</h2>
      <div className="bg-white p-4 md:p-6 rounded-xl shadow">
        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="text-gray-700 border-b">
                <th className="py-2 px-4 whitespace-nowrap">User ID</th>
                <th className="py-2 px-4">Name</th>
                <th className="py-2 px-4">Mobile</th>
                {/* <th className="py-2 px-4">Role</th> */}
                <th className="py-2 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map(user => (
                <tr key={user._id} className="border-b hover:bg-gray-50">
                  <td className="py-2 px-4 truncate max-w-[150px]">{user._id}</td>
                  <td className="py-2 px-4">{user.username}</td>
                  <td className="py-2 px-4">{user.mobileNumber}</td>
                  {/* <td className="py-2 px-4">
                    {user.isRole === 1 ? 'Admin' : 'User'}
                  </td> */}
                  <td className="py-2 px-4 space-x-2 whitespace-nowrap">
                    <button 
                      onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} 
                      className="text-blue-600 hover:text-blue-800 text-sm p-1 md:p-2"
                    >
                       👁
                    </button>
                    <button 
                      onClick={() => handleEdit(user)} 
                      className="text-yellow-600 hover:text-yellow-800 text-sm p-1 md:p-2"
                    >
                        ✏
                    </button>
                    {user.isRole !== 1 && (
                      <button 
                        onClick={() => handleDelete(user._id)} 
                        className="text-red-600 hover:text-red-800 text-sm p-1 md:p-2"
                      >
                        🗑
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile List */}
        {/* <div className="md:hidden space-y-4">
          {currentUsers.map(user => (
            <div key={user._id} className="border-b p-4 last:border-b-0 hover:bg-gray-50">
              <div className="flex justify-between items-start mb-2">
                <div className="flex-1">
                  <div className="font-medium truncate">{user.username}</div>
                  <div className="text-sm text-gray-500 truncate">ID: {user._id}</div>
                </div>
             
              </div>
              <div className="text-sm mb-2">Mobile: {user.mobileNumber}</div>
              <div className="flex flex-col space-y-2">
                <button 
                  onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} 
                  className="text-blue-600 text-sm p-2 text-left hover:bg-blue-50 rounded"
                >
                  View Details
                </button>
                <div className="flex space-x-2">
                  <button 
                    onClick={() => handleEdit(user)} 
                    className="flex-1 text-yellow-600 text-sm p-2 hover:bg-yellow-50 rounded"
                  >
                    Edit
                  </button>
                  {user.isRole !== 1 && (
                    <button 
                      onClick={() => handleDelete(user._id)} 
                      className="flex-1 text-red-600 text-sm p-2 hover:bg-red-50 rounded"
                    >
                      Delete
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div> */}

<div className="md:hidden space-y-4">
        {currentUsers.map(user => (
          <div key={user._id} className="border-b p-4 last:border-b-0 hover:bg-gray-50">
            <div className="flex justify-between items-start mb-2">
              <div className="flex-1">
                <div className="font-medium truncate">{user.username}</div>
                <div className="text-sm text-gray-500 truncate">ID: {user._id}</div>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="text-sm text-gray-600">Mobile: {user.mobileNumber}</div>
              <div className="flex space-x-3">
                <button 
                  onClick={() => navigate(`/admin-dashboard/users/${user._id}`)} 
                  className="text-blue-600 hover:text-blue-800 p-1"
                >
                  👁
                </button>
                <button 
                  onClick={() => handleEdit(user)} 
                  className="text-yellow-600 hover:text-yellow-800 p-1"
                >
                  ✏
                </button>
                {user.isRole !== 1 && (
                  <button 
                    onClick={() => handleDelete(user._id)} 
                    className="text-red-600 hover:text-red-800 p-1"
                  >
                    🗑
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

        {/* Pagination */}
        <div className="flex flex-wrap justify-center mt-4 gap-2">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => paginate(index + 1)}
              className={`min-w-[36px] px-2 py-1 rounded text-sm
                ${currentPage === index + 1 
                  ? 'bg-blue-500 text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>

      {/* Edit User Modal */}
      {modalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4">
          <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-lg">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Edit User</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  value={editUser.username}
                  onChange={(e) => setEditUser({ ...editUser, username: e.target.value })}
                  className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mobile</label>
                <input
                  type="text"
                  value={editUser.mobileNumber}
                  onChange={(e) => setEditUser({ ...editUser, mobileNumber: e.target.value })}
                  className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="flex justify-end space-x-3">
                <button 
                  onClick={() => setModalOpen(false)} 
                  className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded"
                >
                  Cancel
                </button>
                <button 
                  onClick={handleSaveEdit} 
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersPage;